export const hunger = {
  _id: "60a6d86a8c4fd555132afcb3",
  ui: {
    uses: "Unlimited",

    badge: "none",
    image: "cards/music/hunger_png/v2/ui/hunger_png.webp",
    title: "Hunger",

    useType: "Every Clip",
    disabled: false,
    category: "MUSIC",
    flavorText: "I see you watching me with those eyes...",
    hoverEffect: "video",
    explanation: "Pop / Rock",
    hoverEffectSrc: "cards/music/hunger_mp4/v2/ui/hunger_mp4.mp4",
    slug: "hunger",
  },
  userGroups: ["FREE", "TRIAL", "PRO", "INTERNAL"],
  unlimited: true,
  isActive: true,
  cc: {
    model: "Hunger",
  },
  motive: "AMS",
  effect: "MUSIC",
  scopeUse: ["FREE", "PRO", "SUPERSTAR", "INTERNAL", "TRIAL"],
  scopeVis: ["FREE", "PRO", "SUPERSTAR", "INTERNAL", "TRIAL"],
  tier: "A",
  blockedCards: [],
  blockedEffects: [],
  linkedCards: [],
  facet: {
    type: ["Music"],
    theme: ["Pop", "EDM", "Dance", "Vocals"],
    series: [],
    game: ["CS:GO"],
    mechanic: [],
    behaviour: ["Every Clip"],
  },
  skipSuggested: false,
};

export const noSignal = {
  _id: "61f9697aa8b0981727a33210",
  ui: {
    uses: "Unlimited",

    badge: "none",
    image: "cards/transitions/nosignal_png/v1/ui/nosignal_png.webp",
    title: "No Signal",

    useType: "Multiple Per Clip",
    disabled: false,
    category: "TRANSITIONS",
    flavorText: "Please stand by...",
    hoverEffect: "video",
    explanation: "VHS Series - Transition",
    hoverEffectSrc: "cards/transitions/nosignal_mp4/v1/ui/nosignal_mp4.mp4",
    slug: "no-signal",
  },
  userGroups: ["INTERNAL"],
  scopeUse: ["INTERNAL", "PRO", "SUPERSTAR", "FREE", "TRIAL"],
  scopeVis: ["INTERNAL", "PRO", "FREE", "SUPERSTAR", "TRIAL"],
  linkedCards: [],
  unlimited: false,
  isActive: true,
  motive: "VHS",
  effect: "TRANSITIONS",

  cc: {
    model: "noSignal",
  },
  tier: "A",
  blockedCards: [],
  blockedEffects: [],
  facet: {
    type: ["Transitions"],
    theme: ["Retro", "Synthwave"],
    series: ["VHS"],
    game: ["CS:GO"],
    mechanic: [],
    behaviour: ["Multiple Per Clip"],
    homepage: {
      active: true,
      header: "Featured Series: VHS",
    },
  },
  skipSuggested: false,
};

export const reboot = {
  _id: "60a6d86a8c4fd555132afcae",
  ui: {
    uses: "Unlimited",

    badge: "none",
    image: "cards/intros/reboot_1_intro_img/v1/ui/reboot_1_intro_img.webp",
    title: "Reboot",

    useType: "Every Clip",
    disabled: false,
    category: "INTRO",
    flavorText:
      "Ever have that feeling where you're not sure if you're awake or still dreaming?",
    explanation: "Glitch Series - Intro",
    hoverEffect: "gif",
    hoverEffectSrc:
      "cards/intros/reboot_1_intro_mp4/v1/ui/reboot_1_intro_mp4.mp4",
    slug: "reboot",
  },
  userGroups: ["TRIAL", "PRO", "INTERNAL"],
  unlimited: true,
  isActive: true,
  cc: {
    model: "glitchReboot",
  },
  motive: "intro",
  effect: "INTRO",

  scopeUse: ["TRIAL", "PRO", "INTERNAL", "SUPERSTAR", "FREE"],
  scopeVis: ["FREE", "TRIAL", "PRO", "INTERNAL", "SUPERSTAR"],
  tier: "D",
  blockedCards: [],
  blockedEffects: [],
  linkedCards: [],
  facet: {
    type: ["Intros / Outros"],
    theme: ["Brand", "Retro", "Synthwave"],
    series: ["Glitch"],
    game: ["Dota 2", "CS:GO"],
    mechanic: [],
    behaviour: ["Every Clip"],
  },
  skipSuggested: false,
};

export const vhs = {
  _id: "61f9661ba8b0981727a33204",
  ui: {
    uses: "Unlimited",

    badge: "none",
    title: "VHS",

    image: "cards/overlay/vhs_png/v1/ui/vhs_png.webp",

    useType: "Once Per Clip",
    disabled: false,
    category: "OVERLAY",
    flavorText: "Be kind, rewind.",
    hoverEffect: "video",
    explanation: "Your clip, 30 years ago",
    hoverEffectSrc: "cards/overlay/vhs_mp4/v1/ui/vhs_mp4.mp4",
    slug: "vhs",
  },
  userGroups: ["INTERNAL"],
  scopeUse: ["INTERNAL", "PRO", "SUPERSTAR", "FREE", "TRIAL"],
  scopeVis: ["INTERNAL", "PRO", "FREE", "SUPERSTAR", "TRIAL"],
  linkedCards: [],
  unlimited: false,
  isActive: true,
  motive: "VHS_OVERLAY",
  effect: "OVERLAY",

  cc: {
    model: "VHSOverlay",
  },
  tier: "C",
  blockedCards: [],
  blockedEffects: [],
  facet: {
    type: ["Overlays"],
    theme: ["Retro", "Synthwave"],
    series: ["VHS"],
    game: ["CS:GO"],
    mechanic: [],
    behaviour: ["Once Per Clip"],
  },
  skipSuggested: false,
};

export const thugLife = {
  _id: "61857be2f4812a0e59b12f35",
  ui: {
    uses: "Unlimited",

    badge: "none",
    title: "Thug Life",

    image: "cards/watermarks/thuglife_png/v1/ui/thuglife_png.webp",

    useType: "Once Per Clip",
    disabled: false,
    category: "MEMES",
    flavorText: "1, 2, 3 and to the 4...",
    hoverEffect: "video",
    explanation: "Reaction - On Last Kill",
    hoverEffectSrc: "cards/watermarks/thuglife_mp4/v1/ui/thuglife_mp4.mp4",
    slug: "thug-life",
  },
  userGroups: ["INTERNAL"],
  scopeUse: ["INTERNAL", "PRO", "SUPERSTAR", "FREE", "TRIAL"],
  scopeVis: ["INTERNAL", "PRO", "FREE", "SUPERSTAR", "TRIAL"],
  unlimited: false,
  isActive: true,
  motive: "LAST_KILL",
  effect: "REACTION",

  cc: {
    model: "overlays/reactions/thuglife_meme.mov",
  },
  tier: "C",
  blockedCards: [],
  blockedEffects: [],
  linkedCards: [],
  facet: {
    type: ["Memes"],
    theme: ["Funny"],
    series: [],
    game: ["Dota 2", "CS:GO"],
    mechanic: ["On Last Kill"],
    behaviour: ["Once Per Clip"],
  },
  skipSuggested: false,
};

export const crossfire = {
  _id: "61f966f8a8b0981727a33208",
  ui: {
    uses: "Unlimited",

    badge: "none",
    title: "Crossfire",
    image: "cards/thumbs/crossfire_png/v1/ui/crossfire_png.webp",

    useType: "Once Per Clip",
    disabled: false,
    category: "SOCIAL",
    flavorText: "You'll get caught up in the...",
    hoverEffect: "static",
    explanation: "VHS Series - Thumbnail",
    slug: "crossfire",
  },
  userGroups: ["INTERNAL"],
  scopeUse: ["INTERNAL", "PRO", "SUPERSTAR", "FREE", "TRIAL"],
  scopeVis: ["INTERNAL", "PRO", "FREE", "SUPERSTAR", "TRIAL"],
  linkedCards: [],
  unlimited: false,
  isActive: true,
  motive: "thumbnail",
  effect: "THUMBNAIL",

  cc: {
    model: "crossfireThumbnail",
  },
  tier: "D",
  blockedCards: [],
  blockedEffects: [],
  facet: {
    type: ["Thumbnails"],
    theme: ["Retro", "Synthwave"],
    series: ["VHS"],
    game: ["Dota 2", "CS:GO", "Fortnite", "LoL"],
    mechanic: [],
    behaviour: ["Once Per Clip"],
  },
  skipSuggested: false,
};

export const zoomHeadshot = {
  _id: "60a6d86a8c4fd555132afca2",
  ui: {
    uses: "Unlimited",

    badge: "none",

    title: "Zoom Headshot!",
    image: "cards/effects/headshot_zoom_img/v2/ui/headshot_zoom_img.webp",

    useType: "Multiple Per Clip",
    disabled: false,
    category: "KILL",
    flavorText: "Lock on and enlarge the Z axis. Enhance!",
    hoverEffect: "gif",
    explanation: "Camera zooms on headshot",
    hoverEffectSrc:
      "cards/effects/headshot_zoom_mp4/v2/ui/headshot_zoom_mp4.mp4",
    slug: "zoom-headshot",
  },
  userGroups: ["FREE", "TRIAL", "PRO", "INTERNAL"],
  unlimited: true,
  isActive: true,
  cc: {
    model: "HSZoom",
  },
  motive: "HEADSHOT",
  effect: "TIMELINE",

  scopeUse: ["FREE", "PRO", "SUPERSTAR", "INTERNAL", "TRIAL"],
  scopeVis: ["FREE", "PRO", "SUPERSTAR", "INTERNAL", "TRIAL"],
  tier: "B",
  blockedCards: [],
  blockedEffects: [],
  linkedCards: [],
  facet: {
    type: ["Special FX"],
    theme: ["Cinematic"],
    series: [],
    game: ["CS:GO"],
    mechanic: ["Special Event", "On Kill"],
    behaviour: ["Multiple Per Clip"],
  },
  skipSuggested: false,
};

export const samurai = {
  _id: "60a6d86a8c4fd555132afca0",
  ui: {
    uses: "Unlimited",

    badge: "none",

    title: "The Samurai",
    image: "cards/sfx/samurai_knife_img/v2/ui/TheSamurai_img.webp",

    useType: "Multiple Per Clip",
    disabled: false,
    category: "AUDIO",
    flavorText: "Sake! Sakeeeee!",
    hoverEffect: "video",
    explanation: "HD Knife Replacement",
    hoverEffectSrc: "cards/sfx/samurai_knife_mp4/v2/ui/TheSamurai_mp4.mp4",
    slug: "the-samurai",
  },
  userGroups: ["FREE", "TRIAL", "PRO", "INTERNAL"],
  unlimited: true,
  isActive: true,
  cc: {
    model: "SamuraiKnifeAudio",
  },
  motive: "KNIFE",
  effect: "TIMELINE",

  scopeUse: ["FREE", "INTERNAL", "SUPERSTAR", "PRO", "TRIAL"],
  scopeVis: ["FREE", "PRO", "SUPERSTAR", "INTERNAL", "TRIAL"],
  linkedCards: [],
  tier: "C",
  blockedCards: [],
  blockedEffects: [],
  skipSuggested: false,
  facet: {
    type: ["Audio FX"],
    theme: ["Knife", "Enhancement"],
    series: [],
    game: ["CS:GO"],
    mechanic: ["Specific Weapon"],
    behaviour: ["Multiple Per Clip"],
  },
};

const backlight = {
  _id: "62cf6e16bc5f6d180b902ba7",
  ui: {
    uses: "Unlimited",

    badge: "new",

    title: "Blacklight",
    image: "cards/filters/blacklight_webp/v1/ui/blacklight_webp.webp",

    useType: "Every Clip",
    disabled: false,
    category: "KILL",
    flavorText:
      "It's like CS:GO meets laser tag meets the back of a Spencers Gifts...",
    hoverEffect: "video",
    explanation: "Filter - Can only apply one per clip.",
    hoverEffectSrc: "cards/filters/blacklight_mp4/v1/ui/blacklight_mp4.mp4",
    slug: "backlight",
  },
  userGroups: ["FREE", "TRIAL", "PRO", "INTERNAL"],
  unlimited: true,
  isActive: true,
  cc: {
    model: "Blacklight",
  },
  motive: "RESHADE",
  effect: "RESHADE",

  scopeUse: ["FREE", "INTERNAL", "SUPERSTAR", "PRO", "TRIAL"],
  scopeVis: ["FREE", "PRO", "SUPERSTAR", "INTERNAL", "TRIAL"],
  linkedCards: [],
  tier: "D",
  blockedCards: [],
  blockedEffects: [],
  skipSuggested: false,
  facet: {
    type: ["Special FX"],
    theme: ["Weather"],
    series: [],
    game: ["CS:GO"],
    mechanic: ["Special Event", "On Kill"],
    behaviour: ["Once Per Clip"],
  },
};

export const featuredCard = {
  _id: "638fcb3e9a996b359b1140a7",
  ui: {
    uses: "Music",
    games: ["CS:GO", "CS2"],
    badge: "none",
    title: "12 Ayys Of Christmas",
    image: "cards/thumbnails/specialfx/webp/12AyysOfChristmas_Thumbnail.webp",
    useType: "Every Clip",
    disabled: false,
    category: "MUSIC",
    hoverEffect: "video",
    explanation:
      "Allstar`s music automatically syncs the best moments of your clip to the beat of the song using our top-secret algorithm. Adding this card will automatically create jump cuts in your clip. Try adding some transitions to smooth things out. If more than one song is chosen, Remix will randomly select which is applied.",
    hoverEffectSrc:
      "cards/thumbnails/music/mp4/12AyysOfChristmas_Thumbnail.mp4",
  },
  facet: {
    type: ["Music"],
    game: ["CS:GO", "CS2"],
    theme: ["Holiday"],
    mechanic: [""],
    series: ["Visual FX"],
    behaviour: ["Every Clip"],
    homepage: {
      active: true,
      header: "NEW Visual Effects",
    },
  },
  cc: {
    src: "model_replace/skeleton_models.zip",
    model: "modelReplace",
    weight: [],
    "9x16src": "model_replace_skellys.cfg",
    mute: {
      condition: "NA",
    },
  },
  scopeUse: ["INTERNAL", "PRO_PLUS"],
  scopeVis: ["INTERNAL", "PRO_PLUS", "FREE"],
  linkedCards: [],
  blockedCards: [],
  blockedEffects: [],
  skipSuggested: true,
  unlimited: false,
  isActive: true,
  motive: "MODEL_REPLACE",
  tier: "B",
  effect: "OVERLAY",

  isBackgroundCard: false,
};
